import { GET_INVOICES, LOGOUT } from './types';
import api from "../utils/api";
import { isGuid } from "../utils/string";
import { send as sendAlert } from './alert';

export const table = (page, size, from, to, order, direction, search="") => async (dispatch) => {
    try {
        ///l/p/:page/s/:size/r/:dateFrom/:dateTo/o/:order/:direction/:search?
        const res = await api.get(`/invoices/l/p/${page}/s/${size}/r/${from}/${to}/o/${order}/${direction}/${search}`);

        dispatch({
            type: GET_INVOICES,
            payload: res.data,
        });

        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const file = (uuid) => async (dispatch) => {
    try {
        ///l/p/:page/s/:size/r/:dateFrom/:dateTo/o/:order/:direction/:search?
        const res = await api.get(`/invoices/file/${uuid}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};